import { assertNever } from '@kofno/piper';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { StringField } from '../../Types';

interface Props {
  field: StringField;
  isDisabled: boolean;
  kind: 'MultiLine' | 'SingleLine';
  onChange: (value: string) => void;
}

const errorClassName = (field: StringField): string =>
  field.errors.length > 0 ? 'border-2 border-red-300 border-solid block rounded-md' : '';

const InputComponent: React.FC<Props> = ({ field, isDisabled, kind, onChange }) => {
  switch (kind) {
    case 'SingleLine':
      return (
        <input
          type="text"
          id={field.name}
          className={clsx(
            'w-full rounded-md border border-solid border-gray-300',
            'mb-1 px-4 py-2.5 text-sm text-gray-700',
            errorClassName(field),
          )}
          placeholder={field.placeholder.getOrElseValue('')}
          onChange={(e) => onChange(e.target.value)}
          disabled={isDisabled}
          value={field.value}
          maxLength={field.maxlength}
          minLength={field.minlength.getOrElseValue(0)}
          pattern={field.pattern.map<string | undefined>((r) => r.source).getOrElseValue(undefined)}
        />
      );

    case 'MultiLine':
      return (
        <textarea
          id={field.name}
          className={clsx(
            errorClassName(field),
            'w-full rounded border border-gray-300 py-3 px-4 text-sm',
          )}
          placeholder={field.placeholder.getOrElseValue('')}
          onChange={(e) => onChange(e.target.value)}
          disabled={isDisabled}
          value={field.value}
          maxLength={field.maxlength}
          minLength={field.minlength.getOrElseValue(0)}
          rows={4}
        />
      );
    default:
      assertNever(kind);
  }
};

export default observer(InputComponent);
